const clean = (value = '') => value
  .replace(/\s+/g, '')
  .replace(/[\u200B-\u200D\uFEFF\u00A0\u0000-\u001F\u007F]/g, '')
  .replace(/\/+$/, '');

// An explicit URL supports local HTTP servers; API_HOST is the deployment fallback.
const apiUrl = clean(process.env.REACT_APP_API_URL);
const apiHost = clean(process.env.REACT_APP_API_HOST);
const backendBase = apiUrl || (apiHost ? `https://${apiHost}` : '');

export default backendBase
  ? (backendBase.endsWith('/api') ? backendBase : `${backendBase}/api`)
  : '/api';
